import React from 'react';
import PaperMui from '@material-ui/core/Paper';
import { BORDER_RADIUS } from '../../constants/theme';

interface PaperProps {
  children: React.ReactNode;
  onClick?: () => void;
  scrollOption?: any;
  elevation?: number;
  variant?: any;
  style?: React.CSSProperties;
  className?: string;
}

const Paper: React.FC<PaperProps> = ({
  children,
  onClick,
  scrollOption = 'unset',
  elevation = 1,
  variant,
  style,
  className
}) => {
  return (
    <PaperMui
      style={{
        borderRadius: BORDER_RADIUS,
        overflowX: scrollOption,
        ...style
      }}
      variant={variant}
      className={className}
      elevation={elevation}
      onClick={onClick}
    >
      {children}
    </PaperMui>
  );
};

export default Paper;
